import EventEmitter from "events";

import LocalStorageUtil from "../utils/LocalStorageUtil";

const LOCAL_STORAGE_KEY = "dcosUserSettings";

function getLocalStorageObject() {
  const localStorageObject = LocalStorageUtil.get(LOCAL_STORAGE_KEY);
  try {
    return JSON.parse(localStorageObject);
  } catch (e) {
    return null;
  }
}

class UserSettingsStore extends EventEmitter {
  getKey(key) {
    const localStorageObject = getLocalStorageObject();
    if (localStorageObject == null) {
      return null;
    }

    return localStorageObject[key];
  }

  setKey(key, value) {
    let localStorageObject = getLocalStorageObject();
    if (localStorageObject == null) {
      localStorageObject = {};
    }

    localStorageObject[key] = value;
    LocalStorageUtil.set(LOCAL_STORAGE_KEY, JSON.stringify(localStorageObject));
  }

  get storeID() {
    return "userSettings";
  }
}

module.exports = new UserSettingsStore();



// WEBPACK FOOTER //
// ./src/js/stores/UserSettingsStore.js